import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './index.scss';
import { initializeApp, LibContext } from 'framework-react-core';
import { getRulesEngineEnv, RULESENGINE_ENV } from './utilities/env';
import { Provider } from 'react-redux';
import { store } from './redux/store';
import App from './App';

function getConfig() {
  const env = getRulesEngineEnv();
  switch (env) {
    case RULESENGINE_ENV.DEV:
      return import('./config/app.dev.json?url');
    case RULESENGINE_ENV.QA:
      return import('./config/app.qa.json?url');
    case RULESENGINE_ENV.UAT:
      return import('./config/app.uat.json?url');
    case RULESENGINE_ENV.PROD:
      return import('./config/app.prod.json?url');
    default:
      return import('./config/app.local.json?url');
  }
}

async function main() {
  const configUrl = await getConfig().then((m) => m.default);
  await initializeApp(configUrl);

  createRoot(document.getElementById('root')!).render(
    <StrictMode>
      <LibContext provideRouter={false}>
        <Provider store={store}>
          <App />
        </Provider>
      </LibContext>
    </StrictMode>
  );
}

main();
